module.exports = __webpack_public_path__ + "img/image-5.7c58241c.webp";